// extracted by css-extract-rspack-plugin
export default {"cls1":"FriendlySutdModal-cls1_QnN","cls2":"FriendlySutdModal-cls2_ZdT FriendlySutdModal-cls1_QnN"};